import React from "react";
import { FluidSection, PageContext, WuiltContext } from "@/shared/types";
import { FluidSectionViewer } from "@/FluidPreview/FluidSectionViewer";

export interface FluidViewerProps {
  data: FluidSection;
  sectionId: string;
  pageContext: PageContext;
  wuiltContext: WuiltContext;
}

export const FluidViewer: React.FC<FluidViewerProps> = ({
  data,
  sectionId,
  pageContext,
  wuiltContext,
}) => {
  return (
    <FluidSectionViewer
      sectionData={data}
      sectionId={sectionId}
      pageContext={pageContext}
      wuiltContext={wuiltContext}
    />
  );
};
